module.exports = __webpack_public_path__ + "static/img/JO.e073df06.svg";